angular.module('bbl.directives.file-model', [])

.directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      element.bind('change', function(evt){
        scope.$apply(function() {
          modelSetter(scope, element[0].files[0]);
          evt.target.value = "";
        });
      });
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/file-model.js
 ** module id = 187
 ** module chunks = 0
 **/